/* eslint-disable consistent-return */
import Vuetify from '@/plugins/vuetify';

const filtrosFn = (item, filtro) => {
  if (filtro === '') {
    return true;
  }

  const { anterior, atual, key, referenciaCliente, referenciaInterna } = item;
  const campos = [
    anterior,
    atual,
    Vuetify.framework.lang.t(`$vuetify.${key}`),
    referenciaCliente,
    referenciaInterna,
  ];

  return campos.some((campo) => (typeof campo === 'string' ? campo.toUpperCase().match(filtro) : false));
};

const separadoresFn = () => (notificacoes, notificacao) => {
  notificacoes.push(notificacao);

  return notificacoes;
};

export default {
  getConfiguracoes(state) {
    return state.configuracoes;
  },

  /**
   * Separa os cards por período (atualizado hoje, esta semana, semana passada, etc...)
   */
  getNotificacoes(state) {
    return state.notificacoes.filter((item) => filtrosFn(item, state.filtro)).reduce(separadoresFn(), []);
  },
};
